// extracted by mini-css-extract-plugin
export var searchIcon = "transport-title-search-module--searchIcon--6d9c0";
export var searchSection = "transport-title-search-module--searchSection--903e1";
export var searchSectionCapsules = "transport-title-search-module--searchSectionCapsules--acf23";
export var searchSectionLabel = "transport-title-search-module--searchSectionLabel--b3064";
export var transportTitle = "transport-title-search-module--transportTitle--108bb";
export var transportTitleSearch = "transport-title-search-module--transportTitleSearch--c51c8";
export var transportTitleSearchBanner = "transport-title-search-module--transportTitleSearchBanner--333b5";
export var transportTitles = "transport-title-search-module--transportTitles--8e722";
export var transportTitlesCriteria = "transport-title-search-module--transportTitlesCriteria--b7da8";